import illustrationBag from '@/assets/imgs/illustration-bag_very_happy.svg'
import illustrationChat from '@/assets/imgs/illustration-chat.svg'
import illustrationCheers from '@/assets/imgs/illustration-cheers.svg'
import illustrationThumbsUp from '@/assets/imgs/illustration-thumbs_up.svg'
import POC_ALL_STATUS from '@/resources/enums/pocAllPossibleStatus'
import { DeliveryType, OrderStatus } from '@/resources/enums'
import { ORDERS_PAGE as dict } from '@/resources/dict'

export const {
  REGISTERED,
  VALIDATED,
  ONBOARDING,
  ASSISTED_OPERATIONAL,
  REJECTED,
  NOT_VALIDATED,
} = POC_ALL_STATUS

export const TIMELINE_STEPS = [
  REGISTERED,
  VALIDATED,
  ONBOARDING,
  ASSISTED_OPERATIONAL,
] as const

export const isTimelineStep = (
  status: string
): status is (typeof TIMELINE_STEPS)[number] =>
  (TIMELINE_STEPS as readonly string[]).includes(status)

export const SORT = Object.freeze({
  DESC: 'DESC',
  ASC: 'ASC',
})

export const DELIVERY_SORT_ORDER = {
  [DeliveryType.TURBO]: 0,
  [DeliveryType.RECEIVE]: 1,
  [DeliveryType.ECONOMY]: 2,
  [DeliveryType.SCHEDULED]: 3,
  [DeliveryType.PICKUP]: 4,
}

export const DELIVERY_SORT_ORDER_CBE = {
  [DeliveryType.TURBO]: 0,
  [DeliveryType.PICKUP]: 1,
  [DeliveryType.RECEIVE]: 2,
  [DeliveryType.ECONOMY]: 3,
  [DeliveryType.SCHEDULED]: 4,
}

/** Seconds — used with `elapsedTime` (seconds) for consumer phone cookie TTL on Kanban. */
export const THREE_HOURS = 3 * 60 * 60

export const ORDER_FEATURE_TOGGLES = {
  PRACTICE_ORDER_CARD: 'seller_practice_order_card',
  PRACTICE_ORDER_GUIDE_TOUR_BUTTON: 'seller_practice_order_guide_tour_button',
} as const

export const courierStatusLabel: { [status: string]: string } = {
  [OrderStatus.DM_ACCEPTED]: dict.cards.courierAccepted,
  [OrderStatus.DM_EN_ROUTE]: dict.cards.courierOnRoute,
  [OrderStatus.DM_PICKED_UP]: dict.cards.courierPickedUp,
}

export const STEPS_INFO = [
  {
    name: 'Cadastrado',
    icon: 1,
    acessibility: 'Você está na etapa 1',
    illustration: {
      src: illustrationCheers,
      alt: 'Ilustração de duas mãos brindando, uma segurando um celular e a outra, uma garrafa.',
    },
  },
  {
    name: 'Validação',
    icon: 2,
    acessibility: 'Você está na etapa 2',
    illustration: {
      src: illustrationThumbsUp,
      alt: 'Ilustração com uma mão com o polegar levantado.',
    },
  },
  {
    name: 'Treinamento',
    icon: 3,
    acessibility: 'Você está na etapa 3',
    illustration: {
      src: illustrationChat,
      alt: 'Ilustração de um balão de conversa.',
    },
  },
  {
    name: 'Inicio',
    icon: 4,
    acessibility: 'Você está na etapa 4',
    illustration: {
      src: illustrationBag,
      alt: 'Ilustração de uma sacola com um emoji sorrindo e com garrafas e latas dentro.',
    },
  },
]

export enum OrdersColumnsLabels {
  NEW_ORDERS = 'new-orders',
  IN_SEPARATION_ORDERS = 'in-separation-orders',
  ON_GOING_ORDERS = 'on-going-orders',
}

export enum CardType {
  REPLACEMENT = 'warm',
  DELETION = 'neutral',
  SELECTION = 'creative',
  DEFAULT = 'fresh',
}

export enum ProductCardEnum {
  REPLACEMENT = 'REPLACEMENT',
  DELETION = 'DELETION',
  SELECTION = 'SELECTION',
  DEFAULT = 'DEFAULT',
}

export const ORDERS_COLUMNS_LABELS = {
  NEW_ORDERS: OrdersColumnsLabels.NEW_ORDERS,
  IN_SEPARATION_ORDERS: OrdersColumnsLabels.IN_SEPARATION_ORDERS,
  ON_GOING_ORDERS: OrdersColumnsLabels.ON_GOING_ORDERS,
}

export const { NEW_ORDERS, IN_SEPARATION_ORDERS, ON_GOING_ORDERS } =
  ORDERS_COLUMNS_LABELS

export const INSTRUCTIONS_ACCEPT_ALL_ORDERS_LINK =
  'https://drive.google.com/file/d/1S22bdhRUFbCeZ9cNJ4UcE9kM1-PHhzWq/view'

export const MAX_ACCEPT_MINUTES = 12
export const MAX_ACCEPT_MINUTES_TURBO = 5
export const MAX_PICKUP_MINUTES = 60
export const MAX_PICKUP_PENDING_MINUTES = 3

export const PREPARE_MODAL_ALREADY_SEEN = 'THURSDAY_MODAL_ALREADY_SEEN'
export const PRODUCTS_MODAL_ALREADY_SEEN = 'TUESDAY_MODAL_ALREADY_SEEN'

export const ASSISTED_OPERATIONAL_MODAL_ALREADY_SEEN =
  'ASSISTED_OPERATIONAL_MODAL_ALREADY_SEEN'

export const FEATURE_DISCOVERY_DYNAMIC_RADIUS_MODAL_LOCAL_STORAGE_KEY =
  'FEATURE_DISCOVERY_DYNAMIC_RADIUS_MODAL_ALREADY_SEEN'

export const DEFAULT_CHANGE_ORDER_STATUS_ATTACHMENT_PAYLOAD = {
  reasons: '',
  attachments: '',
} as const
